export default __webpack_public_path__ + "static/media/check-square.75653de6.svg";